const banners = () => ({
  getBanners: () => fetch(`/banners/banners.json`).then((res) => res.json()),
  getCrouselBanners: () => fetch(`/banners/Crousel-banners.json`).then((res) => res.json()),
});

export default banners;
